import { FC } from 'react';
import { SelfServiceAPI } from 'types';

type FormattedCreditCardProps = Pick<SelfServiceAPI.CreditCardPaymentMethod, 'cardType' | 'lastFourDigits'>;

const FormattedCreditCard: FC<FormattedCreditCardProps> = ({ cardType, lastFourDigits }) => (
  <>
    {cardType ? cardType : 'credit card'} ending in {lastFourDigits}
  </>
);

export default FormattedCreditCard;
